import { useContext } from 'react'
import { UGEContext } from '../context'
import { gradientFromEditor, iconFromEditor, iconScaleFromEditor } from '../utilities/editor'
import { Button, Navigation } from './style'

export { default as CloseButton } from './close'

type Props = {
    className?: string
}

const UGENavigation = ({ className }: Props) => {
    const { activeEditor, allowedEditors, loaded, openEditor } = useContext(UGEContext)

    if (allowedEditors.length <= 1) {
        return null
    }

    return (
        <Navigation className={className}>
            {allowedEditors.map((editor) => {
                const gradient = gradientFromEditor(editor)
                const icon = iconFromEditor(editor)
                const iconScale = iconScaleFromEditor(editor)
                const isActive = editor === activeEditor
                const isDefault = editor === 'default'

                return (
                    <Button
                        disabled={!loaded}
                        gradient={isDefault && !isActive ? undefined : gradient}
                        icon={icon}
                        iconColor="#fff"
                        iconScale={iconScale}
                        inverted={!isActive}
                        key={editor}
                        size="large"
                        onClick={() => openEditor(editor)}
                    />
                )
            })}
        </Navigation>
    )
}

export default UGENavigation
